import React from 'react'
import Rocket from '../icons/Rocket'

const MobileClientUpgradeScreen: React.FC = () => {
  return (
    <div className='relative h-screen w-full overflow-hidden'>
      {/* Main Container */}
      <div className='absolute flex h-full w-full flex-row items-center justify-center gap-2 px-16'>
        {/* Content Container */}
        <div className='order-0 flex w-[286px] max-w-[480px] flex-none flex-grow flex-col items-center gap-5'>
          {/* Rocket Section */}
          <div className='order-0 relative h-[200px] w-[200px] flex-none flex-shrink-0 flex-grow-0'>
            {/* Rocket Illustration */}
            <div className='absolute bottom-0 left-[11.5%] right-[11%] top-[15%] flex-none'>
              <Rocket className='h-full w-full' />
            </div>
          </div>

          {/* Lower Content */}
          <div className='order-1 flex w-[286px] flex-none flex-grow-0 flex-col items-center self-stretch p-0'>
            {/* Title */}
            <div className='order-0 flex w-[286px] flex-none flex-grow-0 flex-row items-center justify-center gap-2.5 self-stretch px-2.5 py-1'>
              <div
                className='order-0 w-[266px] flex-none flex-grow text-center leading-[22px] text-[#2A2B2D]'
                style={{
                  fontFamily: 'font/font-family',
                  fontWeight: 590,
                  fontStyle: 'normal',
                  fontSize: 'font/font-size-base',
                  letterSpacing: 'font/font-letterSpacing-17',
                }}
              >
                Zoom update required
              </div>
            </div>

            {/* Copy */}
            <div className='order-1 flex w-[286px] flex-none flex-grow-0 flex-row items-center justify-center gap-[10px] self-stretch px-[10px] py-2'>
              <div
                className='order-0 w-[266px] flex-none flex-grow text-center text-[14px] font-normal leading-[18px] text-[#686F79]'
                style={{
                  fontFamily: 'font/font-family',
                  letterSpacing: 'font/font-letterSpacing-14',
                }}
              >
                Upgrade to the latest Zoom app on your mobile device to use the
                Google Drive app.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileClientUpgradeScreen
